export const insuranceListKeys = {
  all: () => [...insuranceListKeys.base, "all"] as const,
  base: ["insurance-carriers"] as const,
} as const;
